module.exports = "/images/logo-expensify.svg?c7a90bbf2f1d3176f16aa5e05bb7502f";